module.exports = __webpack_public_path__ + "img/join_5.488f367d.png";